import {components} from "react-select";
import React, {Fragment} from "react";

const Menu = props => {
    const filterButtons = props.selectProps.filterButtons;
    const arrowAutoPlacement = () => {
        return props.selectProps.arrowAutoPlacement ? props.selectProps.arrowAutoPlacement(props.menuPlacement, props.placement) : null;
    }
    return (
        <Fragment>
            {/* todo: arrow-up this must be dynamic */}
            <components.Menu {...props} className={[arrowAutoPlacement(), props.selectProps.classNameMenu].join(' ')}>
                <div className="filter-wrapper">
                    <div className="filter-list">
                        {props.children}
                    </div>
                    <div className='btn-filter'>
                        {
                            filterButtons.cancel ? (
                                <button className="btn secondary sm" onClick={props.selectProps.onCloseClick}>Cancel</button>
                            ) : null
                        }
                        {
                            filterButtons.done ? (
                                <button className="btn primary sm" onClick={props.selectProps.onDoneClick}>Done</button>
                            ) : null
                        }
                    </div>
                </div>
            </components.Menu>
        </Fragment>
    );
};

export default Menu;